/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery,
  type DataTag,
  type MutationFunction,
  type QueryClient,
  type QueryFunction,
  type QueryKey,
  type UseMutationOptions,
  type UseMutationReturnType,
  type UseQueryOptions,
  type UseQueryReturnType,
} from "@tanstack/vue-query"
import { computed, toValue, unref, type MaybeRefOrGetter } from "vue"

import { customInstance, type ErrorType } from ".././client.ts"
import { useMutationOptions } from ".././mutationOptions.ts"
import { useQueryOptions } from ".././queryOptions.ts"
import type {
  AccountLoyaltyDrawResponse,
  ActivePrizeDrawResponse,
  Error,
  GetLoyaltyStatusParams,
  LoyaltyStatusResponse,
  PrizeWinner,
  RecordPrizeDrawEntriesRequest,
} from "../model"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Record entries in the currently active prize draw for an account.
 */
export const recordDrawEntriesForAccount = (
  accountId: MaybeRefOrGetter<number>,
  recordPrizeDrawEntriesRequest: MaybeRefOrGetter<RecordPrizeDrawEntriesRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  recordPrizeDrawEntriesRequest = toValue(recordPrizeDrawEntriesRequest)

  return customInstance<void>(
    {
      url: `/api/v1/accounts/${accountId}/loyalty/draw/entry`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: recordPrizeDrawEntriesRequest,
      signal,
    },
    options,
  )
}

export const useRecordDrawEntriesForAccountMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordDrawEntriesForAccount>>,
    TError,
    { accountId: number; data: RecordPrizeDrawEntriesRequest },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordDrawEntriesForAccount>>,
  TError,
  { accountId: number; data: RecordPrizeDrawEntriesRequest },
  TContext
> => {
  const mutationKey = ["recordDrawEntriesForAccount"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordDrawEntriesForAccount>>,
    { accountId: number; data: RecordPrizeDrawEntriesRequest }
  > = (props) => {
    const { accountId, data } = props ?? {}

    return recordDrawEntriesForAccount(accountId, data, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type RecordDrawEntriesForAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordDrawEntriesForAccount>>
>
export type RecordDrawEntriesForAccountMutationBody =
  RecordPrizeDrawEntriesRequest
export type RecordDrawEntriesForAccountMutationError = ErrorType<Error>

/**
 * @summary Record entries in the currently active prize draw for an account.
 */
export const useRecordDrawEntriesForAccount = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof recordDrawEntriesForAccount>>,
      TError,
      { accountId: number; data: RecordPrizeDrawEntriesRequest },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof recordDrawEntriesForAccount>>,
  TError,
  { accountId: number; data: RecordPrizeDrawEntriesRequest },
  TContext
> => {
  return useMutation(
    useRecordDrawEntriesForAccountMutationOptions(options),
    queryClient,
  )
}
/**
 * Returns the account's eligibility for the currently active prize draw along with their entries if applicable.
 */
export const getActiveDrawInfoForAccount = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<AccountLoyaltyDrawResponse>(
    {
      url: `/api/v1/accounts/${accountId}/loyalty/draw`,
      method: "GET",
      signal,
    },
    options,
  )
}

export const getGetActiveDrawInfoForAccountQueryKey = (
  accountId: MaybeRefOrGetter<number>,
) => {
  return ["api", "v1", "accounts", accountId, "loyalty", "draw"] as const
}

export const useGetActiveDrawInfoForAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveDrawInfoForAccount>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveDrawInfoForAccount>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetActiveDrawInfoForAccountQueryKey(accountId)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveDrawInfoForAccount>>
  > = ({ signal }) =>
    getActiveDrawInfoForAccount(accountId, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveDrawInfoForAccount>>,
    TError,
    TData
  >
}

export type GetActiveDrawInfoForAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveDrawInfoForAccount>>
>
export type GetActiveDrawInfoForAccountQueryError = ErrorType<Error>

export function useGetActiveDrawInfoForAccount<
  TData = Awaited<ReturnType<typeof getActiveDrawInfoForAccount>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActiveDrawInfoForAccount>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetActiveDrawInfoForAccountQueryOptions(
    accountId,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * Returns the currently open prize draw, or 404 if no draw is currently open for entries.
 */
export const getActivePrizeDraw = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ActivePrizeDrawResponse>(
    { url: `/api/v1/loyalty/draw`, method: "GET", signal },
    options,
  )
}

export const getGetActivePrizeDrawQueryKey = () => {
  return ["api", "v1", "loyalty", "draw"] as const
}

export const useGetActivePrizeDrawQueryOptions = <
  TData = Awaited<ReturnType<typeof getActivePrizeDraw>>,
  TError = ErrorType<Error>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getActivePrizeDraw>>,
      TError,
      TData
    >
  >
  request?: SecondParameter<typeof customInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetActivePrizeDrawQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActivePrizeDraw>>
  > = ({ signal }) => getActivePrizeDraw(requestOptions, signal)

  const customOptions = useQueryOptions(
    { queryKey, queryFn, ...queryOptions },
    {},
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getActivePrizeDraw>>,
    TError,
    TData
  >
}

export type GetActivePrizeDrawQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActivePrizeDraw>>
>
export type GetActivePrizeDrawQueryError = ErrorType<Error>

export function useGetActivePrizeDraw<
  TData = Awaited<ReturnType<typeof getActivePrizeDraw>>,
  TError = ErrorType<Error>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActivePrizeDraw>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetActivePrizeDrawQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * Returns a list of loyalty prize winners.
 */
export const getLoyaltyWinners = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PrizeWinner[]>(
    { url: `/api/v1/loyalty/winners`, method: "GET", signal },
    options,
  )
}

export const getGetLoyaltyWinnersQueryKey = () => {
  return ["api", "v1", "loyalty", "winners"] as const
}

export const useGetLoyaltyWinnersQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoyaltyWinners>>,
  TError = ErrorType<Error>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoyaltyWinners>>,
      TError,
      TData
    >
  >
  request?: SecondParameter<typeof customInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetLoyaltyWinnersQueryKey()

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLoyaltyWinners>>
  > = ({ signal }) => getLoyaltyWinners(requestOptions, signal)

  const customOptions = useQueryOptions(
    { queryKey, queryFn, ...queryOptions },
    {},
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getLoyaltyWinners>>,
    TError,
    TData
  >
}

export type GetLoyaltyWinnersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoyaltyWinners>>
>
export type GetLoyaltyWinnersQueryError = ErrorType<Error>

export function useGetLoyaltyWinners<
  TData = Awaited<ReturnType<typeof getLoyaltyWinners>>,
  TError = ErrorType<Error>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoyaltyWinners>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetLoyaltyWinnersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * Returns the loyalty status for an account including tenure, entry count, and eligibility.
 */
export const getLoyaltyStatus = (
  accountId: MaybeRefOrGetter<number>,
  params?: MaybeRefOrGetter<GetLoyaltyStatusParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)
  params = toValue(params)

  return customInstance<LoyaltyStatusResponse>(
    {
      url: `/api/v1/accounts/${accountId}/loyalty/status`,
      method: "GET",
      params,
      signal,
    },
    options,
  )
}

export const getGetLoyaltyStatusQueryKey = (
  accountId: MaybeRefOrGetter<number>,
  params?: MaybeRefOrGetter<GetLoyaltyStatusParams>,
) => {
  return [
    "api",
    "v1",
    "accounts",
    accountId,
    "loyalty",
    "status",
    ...(params ? [params] : []),
  ] as const
}

export const useGetLoyaltyStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoyaltyStatus>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  params?: MaybeRefOrGetter<GetLoyaltyStatusParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoyaltyStatus>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = getGetLoyaltyStatusQueryKey(accountId, params)

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLoyaltyStatus>>
  > = ({ signal }) =>
    getLoyaltyStatus(accountId, params, requestOptions, signal)

  const customOptions = useQueryOptions(
    {
      queryKey,
      queryFn,
      enabled: computed(
        () => toValue(accountId) !== null && toValue(accountId) !== undefined,
      ),
      ...queryOptions,
    },
    { accountId, params },
  )

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof getLoyaltyStatus>>,
    TError,
    TData
  >
}

export type GetLoyaltyStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoyaltyStatus>>
>
export type GetLoyaltyStatusQueryError = ErrorType<Error>

export function useGetLoyaltyStatus<
  TData = Awaited<ReturnType<typeof getLoyaltyStatus>>,
  TError = ErrorType<Error>,
>(
  accountId: MaybeRefOrGetter<number>,
  params?: MaybeRefOrGetter<GetLoyaltyStatusParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoyaltyStatus>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>
} {
  const queryOptions = useGetLoyaltyStatusQueryOptions(
    accountId,
    params,
    options,
  )

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> }

  query.queryKey = unref(queryOptions).queryKey as DataTag<
    QueryKey,
    TData,
    TError
  >

  return query
}

/**
 * Enrols the account in the loyalty programme. Requires eligibility.
 */
export const enrolMembership = (
  accountId: MaybeRefOrGetter<number>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  accountId = toValue(accountId)

  return customInstance<void>(
    {
      url: `/api/v1/accounts/${accountId}/loyalty/membership`,
      method: "POST",
      signal,
    },
    options,
  )
}

export const useEnrolMembershipMutationOptions = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enrolMembership>>,
    TError,
    { accountId: number },
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof enrolMembership>>,
  TError,
  { accountId: number },
  TContext
> => {
  const mutationKey = ["enrolMembership"]
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enrolMembership>>,
    { accountId: number }
  > = (props) => {
    const { accountId } = props ?? {}

    return enrolMembership(accountId, requestOptions)
  }

  const customOptions = useMutationOptions({ ...mutationOptions, mutationFn })

  return customOptions
}

export type EnrolMembershipMutationResult = NonNullable<
  Awaited<ReturnType<typeof enrolMembership>>
>

export type EnrolMembershipMutationError = ErrorType<Error>

export const useEnrolMembership = <
  TError = ErrorType<Error>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof enrolMembership>>,
      TError,
      { accountId: number },
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof enrolMembership>>,
  TError,
  { accountId: number },
  TContext
> => {
  return useMutation(useEnrolMembershipMutationOptions(options), queryClient)
}
